import { render, staticRenderFns } from "./ordersDetail.vue?vue&type=template&id=b8d642a0&scoped=true&"
import script from "./ordersDetail.vue?vue&type=script&lang=js&"
export * from "./ordersDetail.vue?vue&type=script&lang=js&"
import style0 from "./ordersDetail.vue?vue&type=style&index=0&id=b8d642a0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8d642a0",
  null
  
)

export default component.exports